(function () {
  function animateDecor(section) {
    var get = function (pos) {
      return section.querySelector('.cta-custom__side-img--' + pos);
    };
    var leftTop = get('left_top');
    var rightTop = get('right_top');
    var rightMid = get('right_mid');
    var leftMid = get('left_mid');
    var leftBot = get('left_bot');
    var rightExtra = get('right_extra');
    var rightBot = get('right_bot');

    var base = { autoAlpha: 0, duration: 0.8, ease: 'power2.out', transformOrigin: '50% 50%' };
    function from(el, vars) {
      if (!el) return;
      var o = {};
      for (var k in base) o[k] = base[k];
      for (var j in vars) o[j] = vars[j];
      window.gsap.from(el, o);
    }

    // Mirrors the hero decor entrance. gsap.from animates TO the element's
    // current computed transform, so the CSS rotate() on tablet/mobile stays.
    from(leftTop, { x: -150, y: 200, rotation: 200 });
    from(rightTop, { x: 450, y: -150, rotation: 280 });
    from(rightMid, { y: 250, rotation: 200 });
    from(leftMid, { x: -200, y: 250 });
    from(leftBot, { x: 150, y: 180, rotation: 200 });
    from(rightExtra, { x: 200, y: 250 });
    from(rightBot, { x: 200, y: 250, rotation: 200 });
  }

  function setup(section) {
    function reveal() { section.classList.remove('cta-js-init'); }

    // GSAP missing → just show everything, no animation.
    if (typeof window.gsap === 'undefined') { reveal(); return; }

    section.classList.add('cta-js-init'); // hide content + decor until in view
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var contentEls = [
      section.querySelector('.hero-custom__heading'),
      section.querySelector('.hero-custom__divider'),
      section.querySelector('.hero-custom__buttons')
    ].filter(Boolean);

    if (contentEls.length) window.gsap.set(contentEls, { autoAlpha: 0, y: 70 });

    function play() {
      reveal();
      if (reduce) {
        if (contentEls.length) window.gsap.set(contentEls, { autoAlpha: 1, y: 0 });
        return;
      }
      if (contentEls.length) {
        window.gsap.to(contentEls, { autoAlpha: 1, y: 0, duration: 0.8, stagger: 0.1, ease: 'power2.out' });
      }
      var mm = window.gsap.matchMedia();
      mm.add('(prefers-reduced-motion: no-preference)', function () {
        animateDecor(section);
      });
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries, obs) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) { play(); obs.disconnect(); }
          });
        },
        { threshold: 0.2 }
      );
      io.observe(section);
    } else {
      play();
    }
  }

  function init() {
    document.querySelectorAll('.hero-custom--cta').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.hero-custom--cta');
    if (section) setup(section);
  });
})();
